import { Box, makeStyles, Tab, Tabs, Toolbar } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import clsx from "clsx";
import React, { useState } from "react";
import { toAbsoluteUrl } from "../../../../../../../Utils/_helpers";
import * as helpers from '../../../../../../util/helpers';
import { useMobileViewport } from "../../../../../../util/mobileViewPort";
import ConfigurationToastMessage from "../../Util/ConfigurationToastMessage";
import AddinBulk from "./AddinBulk";
import RecordedUploadSound from "./RecordedUploadSound";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "white",
    boxShadow: "none",
  },

  paper: {
    width: "465px",
    maxWidth: "none",
    display: "flex",
    maxHeight: "100%",
    height: "100%",
    margin: 0,
    boxShadow: "0 2px 18px 0 rgba(0, 0, 0, 0.13)",
    border: "solid 1px rgba(210, 201, 197, 0.3)",
    backgroundColor: "white",
    padding: "25px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "17px",
    },
  },
  scrollPaper: {
    alignItems: "baseline",
    width: "100%",
    maxWidth: "none",
    justifyContent: "end",
    [theme.breakpoints.down("md")]: {
      alignItems: "center",
    },
  },

  tabRoot: {
    borderRadius: "4px",
    color: "#464e5f",
    alignItems: "center",
    fontSize: "16px",
    width: "100%",
    minWidth: "100%",
    textTransform: "capitalize",
    "&.Mui-selected": {
      color: "#2c3687",
      fontWeight: theme.typography.fontWeightMedium,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "13px",
      "&.Mui-selected": {
        backgroundColor: "transparent",
      },
    },
  },
  indicator: {
    backgroundColor: "#2a308b",
    width: "50%",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(3),
      backgroundColor: "#443092",
    },
  },
  tabs: {
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      alignItems: "normal",
      paddingTop: theme.spacing(0),
    },
  },
  flexDirection: {
    flexDirection: 'row',
    width: '50%'
  },
  flexDirectionFull: {
    flexDirection: 'row',
    width: '100%'
  },
  indicatorFull: {
    backgroundColor: "#2a308b",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(3),
      backgroundColor: "#443092",
    },
  }
}));

function a11yProps(name, index) {
  return {
    id: `${name}-tab-${index}`,
    "aria-controls": `${name}-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={0}>{children}</Box>}
    </div>
  );
}

const UploadSounds = (props) => {
  const classes = useStyles();
  const tabNameList = ["Sound"]; // "Add in Bulk"

  if (helpers.isAdmin() || helpers.isSuperVisor()) {
    tabNameList.push('Add in Bulk');
  }

  const isMobileView = useMobileViewport();

  const [uploadSoundTabIndex, setUploadSoundTabIndex] = useState(0);
  const [toastInfo, setToastInfo] = useState({
    open: false,
    severity: "info",
    snackbarMessage: "",
  });

  const handleOnTabChange = (event, newValue) => {
    setUploadSoundTabIndex(newValue);
  };

  const handleCloseSnackbar = () => {
    setToastInfo((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  const setToastValue = (open, msg, status) => {
    setToastInfo((prevState) => ({
      ...prevState,
      open: open,
      snackbarMessage: msg,
      severity: status,
    }));
  };

  const closeUploadSoundsDialog = () => {
    setUploadSoundTabIndex(0);
    props.handleCloseUploadSounds();
  }

  return (
    <div>
      <ConfigurationToastMessage
        severity={toastInfo.severity}
        snackbarMessage={toastInfo.snackbarMessage}
        open={toastInfo.open}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <Dialog
        disableBackdropClick
        classes={{
          paper: classes.paper,
          scrollPaper: classes.scrollPaper,
        }}
        style={{ zIndex: "9901" }}
        open={props.openUploadSoundsDialog}
        onClose={closeUploadSoundsDialog}
      >
        <div className="row">
          <div className="col-lg-12">
            <AppBar className={classes.appBar}>
              <Toolbar
                className={`d-flex justify-content-between px-3 ${clsx({
                  "align-items-start": isMobileView,
                })}`}
              >
                <div className="secondary-header d-flex align-items-center">
                  <img
                    className=""
                    src={`${toAbsoluteUrl("/media/sr/icons/audio-track.svg")}`}
                    alt="clock"
                    style={{
                      width: "32px",
                      height: "32px",
                      marginRight: "14px",
                    }}
                  />
                  <div className="d-flex flex-column">
                    <span className="mb-1 pt-3">Recorded Sound</span>
                    <span style={{ fontSize: "12px", color: "#6c7293" }}>
                      Record your own sound file and upload
                    </span>
                  </div>
                </div>
                <img
                  alt="close"
                  src={toAbsoluteUrl("/media/sr/icons/close.svg")}
                  className={`next-arrow-icon ${clsx({
                    "mt-3": isMobileView,
                  })}`}
                  onClick={closeUploadSoundsDialog}
                  style={{ cursor: "pointer", width: "20px", height: "20px" }}
                />
              </Toolbar>
            </AppBar>
            {
              <div
                className={`my-5 ${clsx({
                  "mr-n5 ml-n6": isMobileView,
                  "mr-n7 ml-n7": !isMobileView,
                })}`}
                style={{
                  borderBottom: "solid 1px #e5eaee",
                }}>
                <Tabs
                  value={uploadSoundTabIndex}
                  onChange={handleOnTabChange}
                  TabIndicatorProps={{
                    className: tabNameList.length > 1 ? classes.indicator: classes.indicatorFull
                  }}
                  aria-label="sounds-sub"
                  variant="standar"
                  classes={{
                    flexContainer: tabNameList.length > 1 ? classes.flexDirection: classes.flexDirectionFull,
                  }}
                >
                  {tabNameList.map((tab, index) => {
                    return (
                      <Tab
                        key={tab}
                        className={classes.tabRoot}
                        label={tab}
                        {...a11yProps(tab, index)}
                      />
                    );
                  })}
                </Tabs>
              </div>
              // <div className="my-6">
              //   <RecordedUploadSound
              //     handleCloseUploadSounds={closeUploadSoundsDialog}
              //     editSound={false}
              //     setToastValue={setToastValue}
              //   />
              // </div>
            }

            {
              tabNameList.includes('Sound') &&
              <TabPanel value={uploadSoundTabIndex} index={0}>
                <RecordedUploadSound
                  handleCloseUploadSounds={closeUploadSoundsDialog}
                  editSound={false}
                  setToastValue={setToastValue}
                />
              </TabPanel>
            }
            {
              tabNameList.includes('Add in Bulk') &&
              <TabPanel value={uploadSoundTabIndex} index={1}>
                <AddinBulk
                  handleCloseUploadSounds={closeUploadSoundsDialog}
                  setToastValue={setToastValue}

                />
              </TabPanel>
            }
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default UploadSounds;
